import React, { useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useNavigate, useParams, Link } from "react-router-dom";
import { toast } from "react-toastify";

const AddEnquiryLayer = () => {
    const navigate = useNavigate();
    const { id } = useParams();

    const [formData, setFormData] = useState({
        name: "",
        companyName: "",
        mobileNo: "",
        email: "",
        category: "",
        address: "",
        city: "",
        state: "",
        pincode: "",
        interestedProduct: ""
    });

    const [submitting, setSubmitting] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitting(true);

        // Simulate save to localStorage
        setTimeout(() => {
            const savedEnquiries = JSON.parse(localStorage.getItem(`enquiries_${id}`) || "[]");
            const newEnquiry = {
                ...formData,
                id: Date.now().toString(),
                createdAt: new Date().toISOString(),
                phone: formData.mobileNo, // Mapping mobileNo to phone for consistency
                invitedBy: "Admin",
                interestToBecomeMember: "Yes",
                experienceInMeeting: "Good"
            };
            localStorage.setItem(`enquiries_${id}`, JSON.stringify([...savedEnquiries, newEnquiry]));

            toast.success("Enquiry Added Successfully");
            setSubmitting(false);
            navigate(`/expo/view/${id}`);
        }, 800);
    };

    return (
        <div className="card h-100 p-0 radius-12">
            <div className="card-header border-bottom px-24 py-12 d-flex align-items-center justify-content-between" style={{ background: "linear-gradient(135deg, #000000ff, #bb0007ff, #ff0000ff)" }}>
                <h6 className="text-white pb-2 mb-0" style={{ fontWeight: "700" }}>ADD ENQUIRY</h6>
                <Link to={`/expo/view/${id}`} className="btn btn-sm d-flex align-items-center gap-1" style={{ backgroundColor: "#f7e7da", color: "black", fontWeight: "600" }}>
                    <Icon icon="solar:arrow-left-bold" /> Back
                </Link>
            </div>
            <div className="card-body p-24">
                <form onSubmit={handleSubmit}>
                    <div className="row gy-4">
                        <div className="col-md-6">
                            <label className="form-label fw-bold">Name <span className="text-danger">*</span></label>
                            <input
                                type="text"
                                name="name"
                                className="form-control radius-8"
                                value={formData.name}
                                onChange={handleInputChange}
                                placeholder="Enter Name"
                                Required
                            />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label fw-bold">Company Name <span className="text-danger">*</span></label>
                            <input
                                type="text"
                                name="companyName"
                                className="form-control radius-8"
                                value={formData.companyName}
                                onChange={handleInputChange}
                                placeholder="Enter Company Name"
                                Required
                            />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label fw-bold">Mobile Number <span className="text-danger">*</span></label>
                            <input
                                type="text"
                                name="mobileNo"
                                className="form-control radius-8"
                                value={formData.mobileNo}
                                onChange={handleInputChange}
                                placeholder="Enter Mobile Number"
                                Required
                            />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label fw-bold">Email</label>
                            <input
                                type="email"
                                name="email"
                                className="form-control radius-8"
                                value={formData.email}
                                onChange={handleInputChange}
                                placeholder="Enter Email"
                            />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label fw-bold">Category</label>
                            <input
                                type="text"
                                name="category"
                                className="form-control radius-8"
                                value={formData.category}
                                onChange={handleInputChange}
                                placeholder="Enter Category"
                            />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label fw-bold">Interested Product</label>
                            <input
                                type="text"
                                name="interestedProduct"
                                className="form-control radius-8"
                                value={formData.interestedProduct}
                                onChange={handleInputChange}
                                placeholder="Enter Interested Product"
                            />
                        </div>
                        <div className="col-md-12">
                            <label className="form-label fw-bold">Address</label>
                            <textarea
                                name="address"
                                className="form-control radius-8"
                                rows="3"
                                value={formData.address}
                                onChange={handleInputChange}
                                placeholder="Enter Address"
                            ></textarea>
                        </div>
                        <div className="col-md-4">
                            <label className="form-label fw-bold">City</label>
                            <input
                                type="text"
                                name="city"
                                className="form-control radius-8"
                                value={formData.city}
                                onChange={handleInputChange}
                                placeholder="Enter City"
                            />
                        </div>
                        <div className="col-md-4">
                            <label className="form-label fw-bold">State</label>
                            <input
                                type="text"
                                name="state"
                                className="form-control radius-8"
                                value={formData.state}
                                onChange={handleInputChange}
                                placeholder="Enter State"
                            />
                        </div>
                        <div className="col-md-4">
                            <label className="form-label fw-bold">Pincode</label>
                            <input
                                type="text"
                                name="pincode"
                                className="form-control radius-8"
                                value={formData.pincode}
                                onChange={handleInputChange}
                                placeholder="Enter Pincode"
                            />
                        </div>

                        <div className="col-12 mt-32 d-flex justify-content-end gap-3">
                            <button
                                type="button"
                                className="btn radius-8 px-40 py-11"
                                style={{ backgroundColor: "white", color: "#d9534f", fontWeight: "700", border: '1px solid #d9534f' }}
                                onClick={() => navigate(`/expo/view/${id}`)}
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="btn radius-8 px-48 py-11"
                                style={{ backgroundColor: "#ed1c24", color: "white", fontWeight: "700" }}
                                disabled={submitting}
                            >
                                {submitting ? "Saving..." : "Save"}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddEnquiryLayer;
